import i18n from 'i18n';

export const getRecacheError = errors => {
  const errorText = i18n.t('checkout.payment.spreedly.errors.errors.generic');
  const spreedlyErrorMessages =
    errors?.map(error => error.message).join(', ') ?? '';
  const spreedlyErrorMessagesText = i18n.t(
    'checkout.payment.spreedly.errors.errors.specific',
    { errors: spreedlyErrorMessages },
  );
  if (spreedlyErrorMessages.length > 0)
    return `${errorText} ${spreedlyErrorMessagesText}`;
  return errorText;
};
